// TODO We need to refactor styled components
import styled from 'styled-components';

export const ReportItemContainer = styled.div``;
